/**
 * Scene component extracted from DailyCupScene
 */

class DailyCupSceneComponent extends ScriptComponent {
    onAttach() {
        this.sceneComponent = ComponentMap.get(this.node, SceneComponent);

        this.sceneComponent.setStyling({
            bundle: "daily_cup",
            patternId: bundles.daily_cup.urls.daily_cup_pattern && "daily_cup_pattern",
            backgroundId: "daily_cup_bg"
        });
        this.sceneComponent.setBundles(["daily_cup"]);
    }

    onSceneLoaded() {
        cleverapps.environment.episodeNo = Level.LevelTypes.DAILYCUP;

        this.node.addChild(new DailyCupView(cleverapps.dailyCup));

        cleverapps.playSession.logEventOnce(cleverapps.EVENTS.CUP_DAU + cleverapps.dailyCup.type);
        cleverapps.placements.run(Placements.INTERMEDIATE);
    }

    onPlayIntro(f) {
        const wasShown = cleverapps.dataLoader.load(DataLoader.TYPES.CUP_RULES + cleverapps.dailyCup.type);
        if (wasShown) {
            f();
            return true;
        }

        new GuideWindow({
            name: "DailyCupRulesWindow",
            bundle: bundles.dailycupruleswindow
        });
        cleverapps.focusManager.onceNoWindowsListener = function () {
            cleverapps.dataLoader.save(DataLoader.TYPES.CUP_RULES + cleverapps.dailyCup.type, true);
            f();
        };

        return true;
    }
}

Prefab.registerComponent("DailyCupSceneComponent", DailyCupSceneComponent);
